export const StatusFilterEnum = {
  ALL: 'all',
  ACTIVE: 'active',
  ARCHIVED: 'archived'
};

export const StatusFilterValues = Object.values(StatusFilterEnum); 